import template from "./start-screen-area.html";
import {startScreenAreaController} from "./start-screen-area.controller";
import "./start-screen-area.scss";

export const startScreenAreaComponent = {
    template,
    controller: startScreenAreaController,
    controllerAs: "startArea",
    bindings: {
        model: "=",
        isDisabled: "<",
        relativeSize: "<",
        pixelWidth: "<",
        pixelHeight: "<",
        company: "<",
        hideInputsFields: "<",
        hideUploadIcons: "<",
        shortUploadTitle: "<",
        hideSizeOptions: "<",
        customButtonsOptions: "<",
        hideUpload: "<",
        // Keeps width / height (px) at this ratio: changing one changes the other
        aspectRatio: "<",
        // Out of range values stay in the model (marked invalid) instead of becoming undefined
        keepInvalid: "<",
        // Icon upload limit in mb, instead of the default one
        maxSize: "<",
        // Allowed formats and size, under the upload button
        uploadHint: "@",
        // Width in % of the layout width instead of its height (x/y stay the center)
        screenWidthUnits: "<",
        deletePrevious: "<",
        title: "@"
    }
};



// WEBPACK FOOTER //
// ./sources/components/common/start-screen-area/start-screen-area.component.js